function getModuleSegments(path) {
  return path.split('/').filter(Boolean).slice(0, 2).join('/');
}

// Some edit/detail routes live at a URL unrelated to their parent list (see
// their `goBack` in Constants.js) but should still be treated as a
// continuation of that list rather than a module switch.
const CROSS_PATH_CHILDREN = {
  '/Inventario/ListadoMarcas': ['/Inventario/Item/Edit'],
  '/Usuarios/Lista': ['/Usuarios/Usuario/Edit', '/Usuarios/Usuario/New'],
  '/Inventario/ListadoCompras': ['/Inventario/Compras/NuevaCompra', '/Inventario/Compras/Edit'],
  '/Ventas/ListadoVentas': ['/Ventas/NuevaVenta', '/Inventario/Ventas/Edit'],
  '/Informes/MediosMagneticos': [
    '/Informes/InformesMediosMagneticos/Detalle',
    '/Informes/InformesMediosMagneticosVentas/Detalle',
  ],
};

function isDeclaredChild(parentPath, childPath) {
  const children = CROSS_PATH_CHILDREN[parentPath];
  return !!children && children.some(prefix => childPath.startsWith(prefix));
}

function isSameModule(pathA, pathB) {
  if (getModuleSegments(pathA) === getModuleSegments(pathB)) return true;
  return isDeclaredChild(pathA, pathB) || isDeclaredChild(pathB, pathA);
}

function save(key, inputs, inputs2) {
  try {
    sessionStorage.setItem(key, JSON.stringify({
      inputs,
      inputs2,
      savedPath: window.location.pathname,
    }));
  } catch(e) {}
}

function restore(key) {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch(e) { return null; }
}

function clearIfModuleChanged(key) {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return;
    const data = JSON.parse(raw);
    if (data.savedPath && !isSameModule(data.savedPath, window.location.pathname)) {
      sessionStorage.removeItem(key);
    }
  } catch(e) {}
}

function clear(key) {
  try { sessionStorage.removeItem(key); } catch(e) {}
}

const filterStorage = { save, restore, clearIfModuleChanged, clear };
export default filterStorage;
